import { IGatsbyImageData } from 'gatsby-plugin-image'
import React from 'react'

import { BackgroundImageWrapper, Content, FakeBackgroundImage, Parent, Tilt } from './BackgroundImage.styled'

type BackgroundImageType = {
    image: IGatsbyImageData
    title: string
    height?: string
    mobileHeight?: string
    tabletHeight?: string
    showOnMobile?: boolean
    showOnTablet?: boolean
    overlayColor?: string
    children?: JSX.Element
    className?: string
    testId?: string
    onClick?: () => void
    backgroundImageAnimation?: boolean
}

export const BackgroundImage = ({
    image,
    title,
    height = '100%',
    mobileHeight = '100%',
    tabletHeight = '100%',
    showOnMobile = true,
    showOnTablet = true,
    overlayColor = 'transparent',
    children,
    className,
    testId,
    onClick,
    backgroundImageAnimation,
}: BackgroundImageType): JSX.Element => {
    const Wrapper = backgroundImageAnimation ? Tilt : React.Fragment
    return (
        <Parent overlayColor={overlayColor} data-testid={testId} onClick={onClick}>
            <BackgroundImageWrapper $height={height}>
                <Wrapper>
                    <FakeBackgroundImage
                        image={image}
                        title={title}
                        alt={title}
                        $height={height}
                        $mobileHeight={mobileHeight}
                        $tabletHeight={tabletHeight}
                        $showOnMobile={showOnMobile}
                        $showOnTablet={showOnTablet}
                    />
                </Wrapper>
            </BackgroundImageWrapper>
            <Content className={className}>{children}</Content>
        </Parent>
    )
}
